<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        认证培训机构详情
      </div>
      <div class="flex align-center" v-if="!isExamine">
<!--        <upFileDown  :org_type="2" :org_id="id" class="margin-right"/>-->
        <el-button type="danger" v-if="orgDetail" @click="closeItem(orgDetail.status === 1?0:1)">
          {{ orgDetail.status === 1 ? '冻结机构' : '解除冻结' }}
        </el-button>
      </div>

    </div>
    <div class="padding-sm flex align-start justify-between detail-warpper" v-if="orgDetail">
      <div class="flex-sub info-warpper">
        <h2 class="flex align-center detail-title margin-bottom-xs">
          <span class="margin-right">机构指标</span>
          <el-select v-model="year" placeholder="请选择年份" @change="tongji">
            <el-option
                v-for="item in yearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </h2>
        <div class="flex align-center margin-bottom">
          <div class="detail-num ">
            <span>考生报名数量</span>
            <b><i>{{ bmnum }}</i></b>/
            <b><i>{{ jhbm }}</i></b>
          </div>
          <div class="detail-num ">
            <span>持证教师人数</span>
            <b>{{ czjsnum }}人</b>
            <router-link :to="'/projectOffice/teacherList?id=' + this.id" class="link-text">查看</router-link>
          </div>
        </div>
        <h2 class="flex align-center detail-title margin-bottom-xs"><span>认证培训机构信息</span></h2>
        <el-row class="org-info">
          <el-col :span="4">
            <div class="label-box">机构名称</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.org_name }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">授权编号</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.org_num }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">机构组织代码</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.org_code }}</div>
          </el-col>
<!--          <el-col :span="4">-->
<!--            <div class="label-box">机构所在地</div>-->
<!--          </el-col>-->
<!--          <el-col :span="8">-->
<!--            <div class="info-box">{{ orgDetail.regionArr }}{{ orgDetail.address }}</div>-->
<!--          </el-col>-->
          <el-col :span="4">
            <div class="label-box">联系人姓名</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.username }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">联系人手机号</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.phone }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">联系人职务</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.zhiwu }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">联系人邮箱</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.email }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">到期时间</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.due_date }}</div>
          </el-col>
          <el-col :span="4">
            <div class="label-box">隶属协调中心</div>
          </el-col>
          <el-col :span="8">
            <div class="info-box">{{ orgDetail.xtzx_name }}</div>
          </el-col>
        </el-row>

        <div class="flex align-start margin-tb">
          <h3 class="margin-right">营业执照</h3>
          <el-image
              style="width: 200px; height: 150px"
              :src="imgUrl + orgDetail.org_license"
              :preview-src-list="[imgUrl + orgDetail.org_license]">
          </el-image>
        </div>
<!--        <div class="flex align-start margin-tb" v-if="orgDetail.longitude">-->
<!--          <h3 class="margin-right">地理位置</h3>-->
<!--          <div class="flex-sub">-->
<!--            <div id="map-container" style="width:100%;height:300px;"/>-->


<!--          </div>-->
<!--        </div>-->
<!--        <div class="quest-item">-->
<!--          <p class="quest-title">到达您机构位置的公共交通方式及路线，包括公交、地铁线路，具体哪路公交车，哪条地铁，在哪一站出站</p>-->
<!--          <div class="anwer-info">{{ orgDetail.way }}</div>-->
<!--        </div>-->

<!--        <div>-->
<!--          <h3 class="detail-small-title">二、申请单位生源信息</h3>-->
<!--          <div class="quest-item">-->
<!--            <p class="quest-title">请详细说明生源涞源 诸如：生源来源地、生源行业背景、生源质量（如：学历、从业领域和年限等）、参加研学旅行指导师考试意愿等。</p>-->
<!--            <div class="anwer-info">{{ orgDetail.shengyuan }}</div>-->
<!--          </div>-->
<!--        </div>-->
        <div>
          <h3 class="detail-small-title">二、申请单位师资信息</h3>
          <div class="quest-item">
            <p>请说明贵机构师资情况 诸如：师资人数、有无研学旅行工作经验、有无研学旅行授课经验、有无中旅协颁发的《研学旅行指导师证书》等。</p>
            <div class="anwer-info">{{ orgDetail.shizi }}</div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">三、申请单位课程信息</h3>
          <div class="quest-item">
            <p>请详细说明培训课程情况 诸如：申请单位研学旅行课程特色、课时、教材、教学方法、评价方法，课程从何时开始对外招生、历史招生情况、学生反馈、毕业后学生在研学旅行行业从业状况等。</p>
            <div class="anwer-info">{{ orgDetail.kecheng }}</div>
          </div>
          <div class="quest-item" v-if="orgDetail.kecheng_file">
            <p class="quest-title">其他附加材料及文档</p>
            <div class="anwer-info">
              <el-link type="primary" :href="fileUrl + orgDetail.kecheng_file" target="_blank">
                附件：{{ orgDetail.kecheng_file }}（点击下载）
              </el-link>
            </div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title padding-top padding-bottom-xs">四、计划考量</h3>
          <ul class="table-box margin-left">
            <li class="active">考试日期</li>
            <li class="active">3月11日</li>
            <li class="active">6月3日</li>
            <li class="active">9月2日</li>
            <li class="active">12月2日</li>
            <li class="active">合计</li>
            <li>考生数量</li>
            <li>{{orgDetail.february_num}}</li>
            <li>{{orgDetail.june_num}}</li>
            <li>{{orgDetail.september_num}}</li>
            <li>{{orgDetail.four_num}}</li>
            <li>{{Number(orgDetail.february_num) +Number(orgDetail.june_num)+Number(orgDetail.september_num)}}</li>
          </ul>
          <div class="margin-left margin-bottom">
            <p>1.统考日考量，包括统考当天和统考日前专场考试考量。 </p>
            <p>2.合计不得低于30。</p>
          </div>

        </div>
        <div>
          <h3 class="detail-small-title">五、认证培训机构合作规则确认函</h3>
<!--          <div class="quest-item">-->
<!--            <p class="quest-title">申请单位工作计划”“请说明取得认证后1年内的招生人数</p>-->
<!--            <div class="anwer-info">{{ orgDetail.zhaosheng }}</div>-->
<!--          </div>-->
<!--          <div class="quest-item">-->
<!--            <p class="quest-title">请说明取得认证后1年内的报考人数</p>-->
<!--            <div class="anwer-info">{{ orgDetail.renshu }}</div>-->
<!--          </div>-->
          <div class="quest-item">
            <p class="quest-title">认证培训机构合作规则确认函</p>
            <div class="anwer-info">
              <el-link type="primary" :href=" fileUrl +orgDetail.zhaosheng_file" target="_blank">
                附件:{{ orgDetail.zhaosheng_file }}（点击下载）
              </el-link>
            </div>
          </div>
        </div>
        <div>
          <h3 class="detail-small-title">六、其他信息</h3>
          <div class="quest-item">
            <p class="quest-title">备注信息</p>
            <div class="anwer-info">{{ orgDetail.remark }}</div>
          </div>
        </div>
        <div class="margin-tb flex align-center justify-around" v-if="isExamine">
          <nianExamine :org-type="2" :xtzx_id="orgDetail.xtzx_id"/>
        </div>
      </div>
      <time-list :id="id" :type="2"/>

    </div>
  </div>
</template>
<script>
import loadBMap from "@/tools/utils";
import {orgOne, orgSet, orgTongji,shenheDetail} from "@/api/projectOffice";
// import {CodeToText} from "element-china-area-data";
import {IMGURL, FILEURL} from "@/config";
import timeList from "@/views/projectOffice/page/conponents/timeList";
import nianExamine from "@/views/projectOffice/page/conponents/nianExamine";
// import upFileDown from "@/components/upFileDown";

export default {
  name: "organizationDetail",
  data() {
    return {
      id: 0,
      year: '',
      yearOptions: [],
      bmnum: 0,
      czjsnum: 0,
      jhbm: 0,
      orgDetail: null,
      isExamine: false
    }
  },
  computed: {
    imgUrl() {
      return IMGURL
    },
    fileUrl() {
      return FILEURL
    }
  },
  components: {
    timeList,
    nianExamine,
    // upFileDown
  },
  created() {
    this.id = Number(this.$route.query.id)
    if (this.$route.query.nian && (Number(this.$route.query.shenType) === 0 || Number(this.$route.query.shenType) === 1)) this.isExamine = true
    this.$emit(
        "setIndex",
        this.isExamine ? '/projectOffice/annualReview' : '/projectOffice/organization',
        "当前位置：机构管理 > <span>认证培训机构详情</span> ",
        true
    );
    this.getDetail();
    this.tongji();
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap

  },
  methods: {
    //  统计
    async tongji() {
      let _data = await orgTongji(this.id, 2, this.year)
      _data.data.year.map(item => {
        this.yearOptions.push({label: item + '年', value: item})
      })
      this.year = _data.data.year[_data.data.year.length - 1]
      this.bmnum = _data.data.data.bmnum
      this.czjsnum = _data.data.data.czjsnum
      this.jhbm = _data.data.data.jhbm
    },
    //  详情
    async getDetail() {
      let _data = this.$route.query.nian?await shenheDetail(this.$route.query.shenId,2) :  await orgOne(this.id, 2)
      // let _arr = _data.data.region_text.split(',')
      // _data.data.regionArr = CodeToText[_arr[0]] + CodeToText[_arr[1]] + CodeToText[_arr[2]]
      // _data.data.latitude = Number(_data.data.latitude)
      // _data.data.longitude = Number(_data.data.longitude)
      this.orgDetail = _data.data
      if (this.orgDetail.longitude) {
        this.$nextTick(() => {
          this.initMap();
        })
      }
    },
    //  冻结
    closeItem(state) {
      this.$confirm(state === 0 ? "确定要冻结该机构吗？" : "确定要解除该机构的冻结吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureClose(state);
      });
    },
    async sureClose(state) {
      let _state = await orgSet(this.$route.query.id, 2, state);
      this.getDetail();
      this.$message.success(_state.msg);
    },

    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(this.orgDetail.longitude, this.orgDetail.latitude);
      this.map.centerAndZoom(point, 13);
      // this.map.enableScrollWheelZoom(true);

      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, {enableDragging: true});
      this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
      // 6、浏览器定位
      // this.geolocation()
      // 7、绑定点击地图任意点事件
      // this.map.addEventListener('click', function (e) {
      //   that.getAddrByPoint(e.point)
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-warpper {
  .info-warpper {
    .detail-title {
      height: 60px;

      span {
        display: block;
        line-height: 29px;
        font-size: 22px;
        padding-left: 15px;
        position: relative;

        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: '';
          width: 8px;
          height: 29px;
          background-color: #009688;
          border-radius: 4px;
        }
      }
    }

    .detail-num {
      width: 30%;
      padding: 10px;
      background-color: #ffffff;
      border: solid 1px #dae6f1;
      font-size: 18px;
      margin-right: 3%;

      span {
        display: block;
        margin-bottom: 10px;
      }

      b {
        i {
          color: #009688;
        }
      }

      .link-text {
        margin-left: 10px;
        color: #009688;
        font-size: 18px;
      }
    }


    .org-info {
      .label-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #eef7ff;
        border: solid 1px #dae6f1;
      }

      .info-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #fff;
        border: solid 1px #dae6f1;
      }
    }

    .detail-small-title {
      line-height: 30px;
      font-size: 18px;
    }

    .quest-item {
      margin: 10px 0 20px;
      padding-left: 32px;

      .quest-title {
        margin-bottom: 10px;
      }

      .anwer-info {
        width: 100%;
        padding: 15px;
        background-color: #f1f1f1;
        border-radius: 4px;
      }
    }
  }


}
.table-box{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  margin-bottom: 20px;
  li{
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 183px;
    height: 40px;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 20px;
    text-align: center;
    font-size: 18px;
    &.active{
      background: #009787;
      color: #fff;
      font-size: 18px;
    }
  }
}
</style>
